import * as React from "react";
const Component = props => <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 1000 1000" {...props}><rect width="100%" height="100%" fill="transparent" /><path d="M945 1950c-16-18-20-19-35-5-25 23-68 18-97-11-18-18-29-22-36-15-27 27-95 2-109-39-3-9-10-9-31 1-24 11-31 10-54-7-15-11-29-26-31-33s7-1 22 13c14 14 32 26 41 26 21 0 65-44 65-65s-45-65-66-65c-9 0-29 14-44 30-17 18-42 32-62 35l-33 5 30-10c54-17 73-71 37-103-59-53-135 27-84 87 17 21 17 21-5 2-13-11-23-29-23-41 0-18-4-21-25-17-27 5-75-21-75-40 0-7 9-2 20 10 25 27 61 28 83 4 20-22 22-73 5-90-14-14-78-16-78-2 0 6 13 10 29 10 17 0 32 4 35 9s-8 8-26 7c-26-1-33 4-40 24-7 22-7 21-4-7 3-40-9-43-22-5-8 22-11 23-11 7-1-14-8-21-23-22-33-3-71-50-64-79 5-18 1-24-16-27q-25.5-4.5 9-6c46-2 70-39 53-81-21-50-74-53-105-6-16 23-16 28 0 58 15 31 15 32-2 16-11-12-17-31-16-58s-2-40-11-40c-26 0-48-38-44-76 3-30-1-41-24-64-31-32-35-57-13-86 13-17 13-16 3 12-23 63 35 107 90 68 49-34 13-113-47-101-62 13-106-65-67-118 12-17 12-22-5-44-10-13-19-31-19-40s8 0 18 19c30 61 112 51 112-14 0-60-60-87-100-44-11 12-20 17-20 11s7-16 15-23c13-11 13-15 0-33-22-31-18-70 9-96 21-19 22-26 13-51-13-35 4-79 33-87 17-4 19-11 14-42-4-28-1-41 16-58 11-13 27-23 35-23 10 0 15-11 15-35 0-39 28-75 58-75 14 0 18-6 15-28-6-36 28-72 67-72 25 0 30-4 30-25 0-34 33-65 69-65 22 0 30-6 35-25 9-34 61-60 91-47 20 9 24 8 29-13 8-31 40-48 80-42 24 3 36-1 53-19 23-25 66-31 92-15 11 7 21 3 38-15 26-28 74-32 94-8 11 14 14 14 23 2 22-30 56-41 86-28 16 7 31 18 34 27 5 12 9 12 28-1 34-24 73-20 96 9 17 22 22 23 50 13 37-14 81 2 89 31 4 16 13 19 51 18 41-2 48 1 67 30 17 26 25 30 48 26 32-6 77 28 77 59 0 13 8 18 28 18 39 1 64 24 71 67 6 32 3 41-16 56-56 45 4 123 70 90 36-18 39-74 5-97-12-9-18-16-12-16 20 0 44 37 44 68 0 27 4 32 23 32 26 0 57 28 57 51 0 8-6 3-13-11-19-37-80-41-102-6-36 55 16 111 75 81 16-8 31-23 34-32 4-14 4-14 3 2-2 13 9 28 28 41 25 17 30 27 30 62 0 32 5 45 23 57 12 9 22 24 22 33-1 14-2 14-12-3-23-41-66-47-98-15-26 26-25 55 1 81 25 25 64 19 92-13 13-16 17-17 17-5 0 9-5 19-10 22-6 4 0 15 15 27 29 23 33 62 9 96-14 20-14 24 0 38 20 20 20 63 1 91-13 18-13 24 0 51 17 34 8 74-21 90-15 8-16 14-5 39 14 35-1 79-31 89-15 4-18 12-13 42l5 37-12-35c-17-45-56-60-92-36-30 19-35 65-10 90 20 21 63 20 86-1 18-16 18-16 12 0-3 10-17 20-29 23-19 5-23 11-20 37 1 18 0 23-2 12-12-52-73-73-106-37-36 39-9 101 44 103 17 1 19 3 7 6s-18 14-18 34c0 36-31 69-65 69-20 0-25 5-25 25 0 34-33 65-70 65-19 0-30 5-30 14 0 7-10 26-22 41-18 23-26 26-60 22-28-4-38-2-38 9 0 8-10 24-21 35-18 18-29 20-65 15-24-3-44-2-44 3 0 12-29 41-40 41-5 0 2-11 16-25 26-27 26-55-1-84-20-21-66-17-87 9-24 30-23 46 7 75 13 14 21 25 17 25-5 0-13-5-20-12-9-9-16-5-32 15-24 31-63 35-97 12-18-13-22-12-38 5-24 26-76 26-100 0m86 0c24-13 26-66 2-92-35-39-93-9-93 48 0 47 44 69 91 44m-117-22c21-30 20-50-4-76-40-43-100-16-100 44 0 54 73 76 104 32m262-3c38-58-36-125-88-78-24 21-24 78 0 92 31 19 70 13 88-14m-394-22c38-34 7-103-46-103-27 0-56 33-56 64 0 48 64 73 102 39m640-40c24-21 23-58-2-83-55-55-135 24-83 82 20 22 61 23 85 1m118-63c39-39 21-78-34-72-30 4-35 8-39 36l-4 31-1-32c-2-36 24-58 54-46 12 4 15 3 10-5-11-18-51-14-69 6-55 61 24 141 83 82m102-77c24-22 23-52-4-80-25-27-45-29-76-7-26 18-30 65-6 88 20 21 63 20 86-1m-786-10c19-58 31-77 58-94 42-25 56-24 56 6 0 20 5 25 25 25s25-5 25-25c0-59 100 6 113 74 5 22 12 31 27 31 25 0 26-22 1-76-21-45-70-88-113-99-24-6-28-12-28-41 0-34 1-34 45-34h45v81l58-3 57-3 3-37c3-30 7-38 23-38s19 7 19 55c0 52 1 55 25 55 26 0 26 0 23-77l-3-78h-90l1-38v-37h-116v35c0 35 0 35-45 35h-45v-40c0-36-2-40-25-40-22 0-25 4-25 40v40H870v-110h-45c-33 0-45 4-45 15 0 8 9 15 20 15 18 0 20 7 20 65v65h150v34c0 30-4 35-31 41-59 13-129 97-129 156 0 25 38 26 46 2m164-13c0-25-4-30-25-30s-25 5-25 30 4 30 25 30 25-5 25-30m250-35c0-20-5-25-25-25s-25 5-25 25 5 25 25 25 25-5 25-25m80 0c0-20-5-25-25-25s-25 5-25 25 5 25 25 25 25-5 25-25m382-32c18-16 25-68 10-77-4-2-23-1-42 3-30 6-35 11-35 34 1 15-3 27-8 27-4 0-7-15-5-32 3-29 7-33 36-36 35-4 35-22 0-22-30 0-58 28-58 58 0 54 62 81 102 45m-1376-28c34-52-29-115-80-82-33 22-41 52-22 82 23 35 79 35 102 0m-140-221c37-55-25-117-80-80-19 12-26 25-26 49 0 42 15 57 57 57 24 0 37-7 49-26m534-129v-95h70v120h200v-25c0-24-2-25-75-25h-75v-180h100v45c0 41 2 45 25 45s25-4 25-45c0-33 4-45 15-45s15 12 15 45c0 43 1 45 30 45s30-2 30-45c0-25 5-45 10-45 6 0 10 20 10 45 0 43 1 45 30 45s30-2 30-45c0-33 4-45 15-45 12 0 15 16 15 80 0 79 0 80 25 80h25V990H700v360h25c25 0 25 0 25-95m600-45v-140h-50v280h50zm565 85c30-29 31-46 8-73-29-34-75-33-99 3-20 30-11 61 24 80 36 19 39 19 67-10m-955 5c0-5-18-10-40-10s-40 5-40 10c0 6 18 10 40 10s40-4 40-10m190-40c0-16-7-20-30-20s-30 4-30 20 7 20 30 20 30-4 30-20m120 0c0-15-7-20-25-20s-25 5-25 20 7 20 25 20 25-5 25-20m-162-72c3-25 0-28-27-28-26 0-31 4-31 23 0 30 9 39 35 35 13-2 21-12 23-30m75 23c4-1 7-12 7-26 0-21-5-25-30-25s-30 4-30 23c0 29 6 36 28 32 9-2 20-4 25-4m327-106V990h-140v30c0 28 2 30 40 30h40v60c0 57-1 60-25 60-20 0-25 5-25 25 0 24 3 25 55 25h55zm439 58c14-17 19-33 15-47-10-35-20-38-58-22-33 14-36 18-31 43 5 23 4 25-5 10-17-27-2-56 33-66l32-9-31-1c-33-1-47 10-58 46-5 17-1 29 18 48 32 32 59 32 85-2m-1519-12c15-29 13-31-20-25-25 6-30 3-36-20-19-76 44-170 122-182 24-3 44-10 44-15 0-15 46-40 137-73 48-18 111-45 140-60 132-66 185-183 132-288-18-35-23-39-35-26-13 12-12 18 2 47 23 47 11 94-39 148-52 56-122 93-179 93-81 0-269 132-325 227-34 59-38 139-9 172 24 26 52 27 66 2m1226-6c32-49 16-132-39-208-58-77-223-178-310-188-46-6-73-16-116-46-88-60-120-137-86-202 13-25 13-31 0-41-12-10-18-6-35 22-43 71-23 174 47 240 34 32 120 75 235 118 49 18 98 43 110 55 13 12 41 25 62 29 77 14 145 121 117 182-9 21-17 25-36 21-27-5-33 11-13 31 19 19 46 14 64-13m-1510-10c36-55-25-117-80-81-30 19-35 65-10 90 24 25 71 20 90-9m524-60v-85H490v170h180zm-338 17c-3-46 1-68 19-107 28-60 116-148 193-195 79-47 103-70 85-81-21-13-85 29-163 107-116 115-174 236-147 303 8 17 14 31 15 31s0-26-2-58m1368-17c0-62-48-150-129-236-74-80-163-145-181-134-22 13-7 31 52 65 34 19 97 69 139 110 86 85 116 148 106 223-4 27-2 36 4 26 5-7 9-32 9-54m254-34c23-25 17-70-12-89-20-13-22-13-16 1 4 11-1 16-18 19-20 3-23 8-20 38 1 26 0 31-8 20-15-24-12-58 7-69 10-5 15-12 11-16-11-11-48 33-48 57 0 52 69 78 104 39m-259-82c-25-71-61-124-130-193-94-94-133-122-148-107-9 10-7 16 13 29 94 64 201 180 247 269 15 28 29 51 30 49 2-2-4-23-12-47M418 841c19-24 68-71 109-104 69-57 90-87 59-87-8 0-59 44-114 98-77 75-106 112-131 163-42 90-39 108 5 34 20-33 52-80 72-104m1534 72c25-23 23-68-4-87-30-21-54-20-78 4-55 55 24 136 82 83M350 868c47-76 96-131 167-188 60-48 80-80 49-80-20 0-190 170-211 210-19 37-46 110-40 110 2 0 18-23 35-52m1334-10c-15-42-40-75-118-155-55-57-105-103-113-103-28 0-12 38 28 66 56 39 160 153 189 208 14 25 26 43 28 41 3-2-4-28-14-57M142 883c10-9 18-27 18-40 0-28-33-63-60-63-26 0-60 34-60 62 0 50 63 76 102 41m1507-140c-37-62-106-149-141-178-33-28-33-28-36-6-3 17 11 36 56 76 32 30 76 77 97 104 44 58 58 60 24 4m-1467 1c25-55-19-106-73-84-34 14-47 50-31 85 18 40 86 39 104-1m368-186c0-10-4-18-8-18-22 0-192 206-192 234 0 3 45-40 100-96s100-110 100-120m141 162c21-12 23-18 9-40-7-12-12-12-29 4-37 34-23 59 20 36m679 1c0-5-8-19-19-32-16-20-21-22-35-10-15 13-15 15 0 32 18 19 54 26 54 10m268-53c-41-77-147-194-148-163 0 12 18 39 41 60 22 22 61 68 87 103 25 34 48 62 50 62s-12-28-30-62m-1240 0c22-29 60-74 86-99 25-26 46-54 46-63 0-41-92 58-155 167-36 62-25 60 23-5m370 44c15-10 5-45-11-39-6 2-17 13-25 25-13 20-13 22 4 22 11 0 25-4 32-8m522-3c0-12-29-38-42-39-13 0-9 38 5 43 22 9 37 7 37-4m597-40c19-17 16-56-7-79-55-55-135 24-83 83 19 20 63 18 90-4m-1222-1c29-13 31-21 11-37-12-10-19-8-35 8-37 37-25 51 24 29m539-35c-26-35-36-37-52-13-11 18-9 22 20 40 42 25 60 11 32-27m186 34c0-8-8-21-18-30-14-13-21-14-30-5-18 18-15 28 11 38 31 12 37 12 37-3m-629-14c29-17 38-33 19-33-5 0-10-8-10-17-1-14-6-12-25 10-23 26-33 57-19 57 3 0 19-8 35-17m99-3c14-11 20-20 13-20-6 0-15-10-19-22-7-22-7-22-30 6-44 50-17 78 36 36m440 7c0-8-11-23-23-36-22-20-25-20-38-5-11 14-10 18 11 35 29 22 50 24 50 6M218 644c26-18 30-65 6-88-8-9-29-16-44-16-58 0-79 83-28 108 32 15 40 14 66-4m426-33c17-18 16-20-5-26-21-7-49 14-49 37 0 15 37 8 54-11m100-21c20-22 36-45 36-50 0-22-40-8-69 25-32 37-36 47-24 58 12 12 20 7 57-33m586 23c0-20-58-83-77-83-23 0-14 23 24 62 41 42 53 47 53 21m88 1c-4-24-35-41-48-28-8 8-7 16 5 28 21 21 47 21 43 0m-589-33c19-27 19-29 3-35-9-3-22-8-29-12-13-6-28 49-18 66s23 12 44-19m401-5c0-34-20-61-28-38-2 7-10 12-18 12-20 0-18 12 6 38 29 31 40 27 40-12m-326 8c11-28 6-52-10-58-24-9-24-9-24 34 0 41 21 57 34 24m244-27c2-20 1-37-2-37-21 0-36 16-36 39 0 56 33 53 38-2m-538-22c0-23-2-24-20-13-11 7-20 23-20 36 0 20 3 21 20 12 12-6 20-21 20-35m824-6c-22-24-34-24-34 0 0 11 10 27 23 36 20 14 22 14 25 0 2-9-4-25-14-36m-738 8c26-23 27-25 11-47l-16-23-30 31c-51 51-19 85 35 39m682 0c2-9-8-28-23-41-25-23-27-24-45-8-17 16-17 18 12 45 31 30 51 31 56 4m-1088-7c25-25 25-55 0-80-40-40-100-13-100 44 0 50 63 73 100 36m265-81c51-27 57-39 19-39-35 0-77 32-114 85-40 58-38 63 10 17 21-21 59-50 85-63m1018 70c-28-49-99-109-128-109-37 0-31 12 19 38 24 13 61 41 82 63 21 21 40 39 42 39s-5-14-15-31m-713-14c15-18 13-21-23-30-28-7-32-1-21 29 8 20 28 20 44 1m340-11c0-22-3-24-22-18-31 9-33 11-18 29 20 23 40 18 40-11m-626 10c9-3 16-13 16-21 0-10-6-13-16-9-9 3-18 6-20 6s-4 7-4 15c0 17 2 18 24 9m896-2c0-10-22-32-32-32-13 0-9 28 5 33 19 8 27 8 27-1m-821-26c9-10 9-16 1-21-12-7-40 11-40 26 0 14 26 10 39-5m747-5c-10-11-25-17-33-14-14 5-13 8 3 20 10 7 24 13 32 13 12 0 12-4-2-19m-627 0c12-8 13-12 1-25-12-15-14-15-31 0-11 10-19 21-19 26 0 11 31 10 49-1m521-5c0-7-7-19-15-26-12-10-18-10-31 1-14 12-14 14 2 26 23 17 44 17 44-1m-932-32c24-16 29-53 12-85-15-28-74-26-94 3-21 30-20 47 6 75 25 27 45 29 76 7m374-15c34-24 45-24 53 1 9 30 51 35 121 17 78-21 140-21 199-1 66 22 107 16 123-19l13-27 28 20c16 11 41 24 56 30 52 20 100-37 60-70-13-10-15-9-15 9 0 44-31 36-85-22-55-61-84-70-117-40-26 23-24 57 3 50 13-3 22 0 26 9 15 39-59 51-89 14-11-14-18-39-18-66 0-37-3-44-19-44-17 0-20 8-23 48-3 45-4 47-37 50-40 4-51-9-51-60 0-27-4-38-15-38-10 0-15 11-15 35 0 75-50 121-97 89-19-12-22-19-14-27 7-7 19-12 28-12 25 0 27-21 4-44-34-34-60-26-116 34-55 60-85 71-85 30 0-28-15-34-24-9-11 30-6 51 17 62 26 13 52 7 89-19m920-56c27-24 23-69-8-89-55-37-117 25-80 80 19 30 60 35 88 9M460 340c24-24 25-48 4-78-31-44-104-20-104 35 0 57 61 82 100 43m540-20c0-29-4-40-15-40s-15 11-15 40 4 40 15 40 15-11 15-40m40 0c0-22-4-40-10-40-5 0-10 18-10 40s5 40 10 40c6 0 10-18 10-40m512-37c25-23 23-68-4-87-30-21-54-20-78 4-55 55 24 136 82 83m-984-21c20-25 15-69-10-86-31-22-45-20-73 9-32 31-31 50 0 81 27 27 59 26 83-4m866-37c25-25 29-54 12-80-31-48-106-24-106 32 0 53 59 83 94 48m-754-15c55-55-24-135-82-83-22 20-23 51-2 81 19 28 57 29 84 2m120-40c38-38 14-100-40-100-39 0-64 31-55 69 11 51 59 67 95 31m518-5c48-61-33-130-88-75-11 11-20 29-20 40 0 27 35 60 64 60 14 0 33-11 44-25m-388-25c11-11 20-29 20-40s-9-29-20-40c-39-39-100-16-100 37 0 57 61 82 100 43m253 8c28-22 32-63 8-87-39-39-101-16-101 37 0 50 54 79 93 50m-142-9c31-16 43-57 25-85-21-31-52-39-81-20-33 22-35 78-3 100 27 19 33 19 59 5" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.513 992.255)" /><path d="M950 1907c0-30 18-47 50-46 20 1 21 2 5 6-31 8-47 25-42 45 3 10 1 18-4 18s-9-10-9-23" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.628 992.26)" /><path d="M820 1895c0-12 5-26 12-33 14-14 54-16 63-3 3 6-7 9-22 8-20-1-30 5-40 23-11 22-13 23-13 5" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.612 992.263)" /><path d="M1093 1885c2-27 6-30 37-32 33-1 34-1 5 5-19 5-32 15-37 32-6 23-7 23-5-5" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.645 992.263)" /><path d="M690 1869c0-24 22-49 45-49 13 0 26 4 29 9 3 4-5 6-18 4-17-4-27 1-35 15-6 11-7 22-4 26 3 3 1 6-5 6-7 0-12-5-12-11" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.596 992.266)" /><path d="M1343 1820c2-33 4-35 37-37 34-1 34-1 5 5-23 6-31 14-37 37-6 29-6 29-5-5" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.676 992.27)" /><path d="M1563 1680c2-31 5-35 32-37 28-2 28-1 5 5-17 5-27 18-32 37-6 29-6 28-5-5" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.703 992.288)" /><path d="M1150 1506c0-20 5-26 21-26 15 0 20 5 17 22-5 34-38 37-38 4" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.652 992.31)" /><path d="M1150 1409c0-25 33-22 38 4 2 12-3 17-17 17-15 0-21-6-21-21" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.652 992.321)" /><path d="M262 1571c4-33 30-48 60-33 22 11 22 11-6 9-23-1-33 4-43 23l-14 25z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.542 992.3)" /><path d="M120 1362c0-42 37-64 70-42 12 8 8 10-14 8-23-2-33 3-43 22-7 14-13 19-13 12" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.525 992.329)" /><path d="M757 1103c-4-3-7-17-7-30 0-20 5-23 35-23 32 0 35 2 35 30 0 26-4 30-28 30-16 0-32-3-35-7" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.603 992.36)" /><path d="M1834 1265c-8-31 10-55 40-54 20 0 20 1-3 10-19 7-22 15-19 39 5 36-9 40-18 5" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.736 992.339)" /><path d="M52 1101c4-33 30-48 60-34 22 11 22 11-6 10-22-2-33 4-43 23l-14 25z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.516 992.359)" /><path d="M550 1075c0-32 2-35 30-35s30 3 30 35-2 35-30 35-30-3-30-35" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.578 992.361)" /><path d="M1874 885c-3-14-4-31-1-39 6-15 47-29 47-15 0 5-7 9-15 9-21 0-29 24-15 49 7 14 7 21 1 21s-13-11-17-25" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.74 992.385)" /><path d="M50 847c-1-41 55-62 80-31 12 13 10 14-14 3-25-12-30-11-47 11-10 14-19 21-19 17" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.517 992.393)" /><path d="M90 703c0-13 22-33 35-33 6 0 20 7 31 15 18 14 17 15-8 5-21-7-31-6-43 6-8 9-15 12-15 7" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.522 992.41)" /><path d="M1803 630c2-33 4-35 37-37 34-1 34-1 5 5-23 6-31 14-37 37-6 29-6 29-5-5" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.733 992.417)" /><path d="M138 590c10-28 56-40 76-20 8 9 4 10-18 4-23-6-32-2-47 17l-19 24z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.526 992.422)" /><path d="M201 490c-1-9 4-21 11-28 14-14 54-16 63-2 4 6-5 7-23 4-23-5-30-1-39 18-8 15-12 17-12 8" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.535 992.436)" /><path d="M283 380c1-19 8-26 31-28 16-2 33 1 39 7 8 8 3 10-21 5-27-6-33-3-42 17l-10 24z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.545 992.448)" /><path d="M1574 335c-8-31 11-55 40-54 20 1 20 2 1 6-26 7-35 23-28 50 3 13 3 23-1 23-3 0-8-11-12-25" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.704 992.453)" /><path d="M371 312c-2-26 20-52 44-52 13 0 26 4 29 8 3 5-8 7-23 4-24-3-30 1-39 25-6 15-11 22-11 15" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.556 992.458)" /><path d="M1471 250c-1-33 16-50 49-49 23 1 23 2-5 8-23 5-31 13-36 36-6 28-7 28-8 5" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.692 992.464)" /><path d="M481 228c-1-35 27-52 61-38 23 10 23 10-2 6-32-7-47 3-53 34-4 25-4 25-6-2" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.57 992.467)" /><path d="M1350 187c0-28 26-49 55-44l30 4-32 2c-28 1-33 5-33 26 0 14-4 25-10 25-5 0-10-6-10-13" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.677 992.473)" /><path d="M591 182c-2-29 20-52 49-52 17 0 30 4 30 8 0 5-13 7-28 4-23-3-29 1-39 25-6 15-11 22-12 15" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.584 992.475)" /><path d="M710 134c0-3 5-14 10-25 11-20 64-27 75-9 4 6-6 7-25 3-26-5-32-2-37 16s-23 31-23 15" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.598 992.48)" /><path d="M1231 134c-1-29 22-46 56-41 27 4 27 4-4 6-24 1-34 7-41 29-9 23-11 24-11 6" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.662 992.48)" /><path d="M841 105c-1-12 4-26 11-33 14-14 54-16 63-2 4 6-5 7-23 4-26-5-31-2-40 22-8 23-11 25-11 9" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.614 992.483)" /><path d="M1111 98c-1-31 27-52 56-41 15 6 13 8-12 13-20 3-31 13-36 30l-7 25z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.648 992.482)" /><path d="M971 83c-1-12 7-27 17-32 21-11 62-4 62 11 0 5-9 4-20-2-24-13-38-6-50 24l-9 21z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.63 992.484)" /><path d="M1219 1880c-12-29 8-60 38-59l28 1-25 7c-17 5-27 16-30 36-4 20-8 25-11 15" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.66 992.265)" /><path d="M571 1818c-1-33 29-53 62-41 20 6 18 8-13 13-26 4-36 11-41 30l-7 25z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.581 992.27)" /><path d="M451 1762c-2-29 20-52 49-52 17 0 30 4 30 8 0 5-13 7-28 4-23-3-29 1-39 25-6 15-11 22-12 15" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.566 992.28)" /><path d="M1800 1546c0-2 8-10 18-17 15-13 16-12 3 4s-21 21-21 13" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.732 992.307)" /><path d="M1730 1490c0-19 7-33 19-40 25-13 41-13 41 0 0 5-6 7-13 4-19-7-40 22-34 46 3 11 1 20-4 20s-9-13-9-30" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.724 992.31)" /><path d="M181 1475c-1-12 4-26 11-33 14-14 54-16 62-3 3 5-8 8-26 7-26-1-33 4-39 24-6 21-7 22-8 5" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.533 992.314)" /><path d="M1793 1370c2-31 5-35 32-37 28-2 28-1 5 5-17 5-27 18-32 37-6 29-6 28-5-5" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.732 992.326)" /><path d="M81 1238c-3-43 32-62 69-38 11 8 6 9-19 8-29-3-36 1-42 22-4 14-7 18-8 8" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.52 992.344)" /><path d="M53 971c3-33 29-48 59-33 22 10 21 11-11 9-29-2-36 2-42 23l-8 25z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.517 992.375)" /><path d="M1846 766c-6-26 1-56 14-56 5 0 17-3 27-6s5 2-10 11c-24 14-27 21-22 46 8 35 0 39-9 5" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.738 992.4)" /><path d="M1741 527c-2-42 45-78 63-48 4 5-2 7-12 4-20-5-37 11-45 42-4 17-5 18-6 2" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.725 992.431)" /><path d="M1661 427c-2-33 18-57 47-56 22 1 23 2 5 6-25 5-39 19-46 48-4 17-5 18-6 2" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.4924 0 0 -.4924 7.715 992.444)" /></svg>;
export default Component;
export { Component as ReactComponent };